import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold me-1" }, "2024 ©", -1)
const _hoisted_4 = {
  href: "{{footer_href}}",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        container: !_ctx.footerWidthFluid
      }]
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("a", _hoisted_4, _toDisplayString(_ctx.footer_title), 1)
      ])
    ], 2)
  ]))
}